/** Matches `.chart-context-menu-plus-btn` in chartContextMenuButton.css */
export const CHART_PLUS_BUTTON_BACKGROUND = '#141722'
export const CHART_PLUS_BUTTON_BACKGROUND_HOVER = '#2d3348'
